module.exports = __webpack_public_path__ + "img/close.5a9f0bbf.svg";